import { controls } from "../controls";

const ms443 = {
  label: "Season Master",
  pageLabel: "Season Master",
  starting: true,
  url: "seasonmaster",
  formActions: { edit: { allow: true } },
  pageType: "history",
  formTabs: {
    allTabs: [
      {
        label: "Basic Info",
        uid: "create",
        style: { fontFamily: "verdana" }
      }
    ]
  },
  filter: [

    ...controls.displayText({ tab: "filter", label: "Crop Type", width: "col-sm-1" }),
    ...controls.text({ tab: 'create', isReadOnly: 'edit', name: "crop_type", isRequired: true, star: true }),
    ...controls.displayText({ tab: "filter", width: "col-sm-4" }),

  ],

  form: [
        {
          widths: "col-sm-8",
          tab: "create",
          title: "Season Details",
          style:{paddingRight:5},
          subComponents: [

            ...controls.displayText({ tab: "create", label: "Season Type", width: "col-sm-2" }),
            ...controls.text({ tab: "create", placeHolder: "Control", name: "season_type", width: "col-sm-4" }),

            ...controls.displayText({ tab: "create", width: "col-sm-2", label: "Description" }),
            ...controls.text({
              isRequired: true, name: "season_desc", width: "col-sm-4"
            }),
            // ...controls.displayText({ tab: "create", label: "", width: "col-sm-4" }),


            ...controls.displayText({ tab: "create", width: "col-sm-2", label: "Season Start" }),
            ...controls.datePicker({
              isRequired: true, name: "season_start", width: "col-sm-4"
            }),

            ...controls.displayText({ tab: "create", width: "col-sm-2", label: "Season End" }),
            ...controls.datePicker({
              isRequired: true, name: "season_end", width: "col-sm-4"
            }),

            // ...controls.displayText({ tab: "create", label: "", width: "col-sm-4" }),

            ...controls.displayText({ tab: "create", width: "col-sm-2", label: "Disbursement Start" }),
            ...controls.datePicker({
              isRequired: true, name: "disbursement_start", width: "col-sm-4"
            }),

            ...controls.displayText({ tab: "create", width: "col-sm-2", label: "Disbursement End" }),
            ...controls.datePicker({
              isRequired: true, name: "disbursement_end", width: "col-sm-4"
            }),
            // ...controls.displayText({ tab: "create", width: "col-sm-4", label: "" }),


            ...controls.displayText({ tab: "create", width: "col-sm-2", label: "Recovery Start" }),
            ...controls.datePicker({
              isRequired: true, name: "recovery_start", width: "col-sm-4"
            }),

            ...controls.displayText({ tab: "create", width: "col-sm-2", label: "Recovery End" }),
            ...controls.datePicker({
              isRequired: true, name: "recovery_end", width: "col-sm-4"
            }),
            // ...controls.displayText({ tab: "create", width: "col-sm-4", label: "" }),


          ],
        },
    {
      widths: "col-sm-4",
      tab: "create",
      title: "Copy Crops From Season",
      subComponents: [
        ...controls.displayText({ tab: "create", label: "Season Type", width: "col-sm-4" }),
        ...controls.text({ tab: "create", placeHolder: "Control", name: "season_type_copy", width: "col-sm-8" }),

        ...controls.displayText({ tab: "create", width: "col-sm-4", label: "Season Start" }),
        ...controls.datePicker({
          isRequired: true, name: "season_start_copy", width: "col-sm-8"
        }),

        ...controls.displayText({ tab: "create", width: "col-sm-4", label: "Season End" }),
        ...controls.datePicker({
          isRequired: true, name: "season_end_copy", width: "col-sm-8"
        }),

        ...controls.displayText({ tab: "create", width: "col-sm-8", label: "" }),
        ...controls.button({
          label: "LOAD", style: { padding: 0 },
          Bcolor: "warning", onclick: {
            action: "loadOldData",
            loadInto: 'disbursement_schedule_table',
            requiredField: ["crop_id", "irrigated_rate", "nonirrigated_rate"]
          }, width: "col-sm-4"
        }),
      ]
    },
    {
      widths: "col-sm-12",
      tab: "create",
      title: "Season Crops",
      subComponents: [

        ...controls.displayText({ tab: "filter", label: "Crop", width: "col-sm-2" }),
        ...controls.text({ placeHolder: "Crop", name: "crop_id", width: "col-sm-2" }),

        ...controls.displayText({ tab: "create", label: "Irrigated Rate", width: "col-sm-2" }),
        ...controls.numberOnly({ tab: "create", name: "irrigated_rate", placeHolder: "", width: "col-sm-2" }),

        ...controls.displayText({ tab: "create", label: "Non Irrigated Rate", width: "col-sm-2" }),
        ...controls.numberOnly({ tab: "create", name: "nonirrigated_rate", placeHolder: "", width: "col-sm-1" }),


        ...controls.button({
          label: "ADD", style: { padding: 0 },
          Bcolor: "success", onclick: {
            action: "appendToHTMLTable",
            tableNameField: 'disbursement_schedule_table',
            requiredField: ["crop_id", "irrigated_rate", "nonirrigated_rate"]
          }, width: "col-sm-1"
        }),
        {
          inputType: "table",
          tableTitle: "",
          // convertedTo: "nominee_table",
          deletable: true,
          // editable: true,
          // addRows: true,
          tableHeaders: [
            { label: "Sr", type: "autoinc" },
            { label: "Crop ID", field: "crop_id" },
            { label: "Irrigated", field: "irrigated_rate" },
            { label: "Non Irrigated", field: "nonirrigated_rate" }
          ],
          widths: {
            parent: "col-sm-12",
            children: "col-sm-12"
          },
          name: "disbursement_schedule_table"
        }
      ]
    }
  ],
  history: {
    perPage: 10,
    reportHeader: "Season Master",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      {
        Header: "Season",
        accessor: "season",
        width: 150, type: "small"
      },
      {
        Header: "Crop Type",
        accessor: "crop_type",
      }
    ]
  }
};

export default ms443;